const DailyCust = () => import('@/views/main/report/dailyCust/DailyCust.vue')
export default {
  path: '/main/report/dailyCust',
  name: 'DailyCust',
  component: DailyCust,
  children: []
}
